import React, { Component } from "react";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import LocationSidebar from "../components/LocationSidebar";

const bg = require("../../../../images/servicehero.png");

class HouseCleaningTweedHeads extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="House Cleaning Tweed Heads | Professional Cleaners"
          description="House cleaning Tweed Heads. Reliable residential cleaning services for homes and apartments."
          keywords="house cleaning tweed heads, cleaning services tweed heads, residential cleaning tweed heads, home cleaning tweed heads, domestic cleaning tweed heads, weekly house cleaning tweed heads, deep cleaning tweed heads, move in cleaning tweed heads, move out cleaning tweed heads, apartment cleaning tweed heads, unit cleaning tweed heads, professional house cleaners tweed heads, affordable house cleaning tweed heads, reliable cleaners tweed heads, same day house cleaning tweed heads, eco friendly cleaning tweed heads, sanitisation cleaning tweed heads, kitchen cleaning tweed heads, bathroom cleaning tweed heads, rental property cleaning tweed heads, relocation cleaning tweed heads, property cleaning tweed heads, holiday home cleaning tweed heads, trusted cleaning company tweed heads, local cleaners tweed heads, house cleaning near me tweed heads, one off cleaning tweed heads, floor cleaning tweed heads, window cleaning tweed heads, complete house cleaning tweed heads"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  House Cleaning Services Tweed Heads
                </h1>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <LocationSidebar activePage="/house-cleaning-tweed-heads/" />
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            House Cleaning Services Tweed Heads
                          </h4>
                          <p>
                            Our house cleaning Tweed Heads service provides
                            professional residential cleaning solutions tailored
                            to busy households.
                          </p>

                          <h4 className="dlab-title m-t30">Services Include</h4>
                          <ul className="list-check primary">
                            <li>Regular cleaning</li>
                            <li>Deep cleaning</li>
                            <li>Move in cleaning</li>
                            <li>Move out cleaning</li>
                          </ul>

                          <h4 className="dlab-title m-t30">
                            Why Choose Our Tweed Heads Cleaners
                          </h4>
                          <ul className="list-check primary">
                            <li>Experienced team</li>
                            <li>Flexible scheduling</li>
                            <li>Reliable service</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default HouseCleaningTweedHeads;
